module.exports = __webpack_public_path__ + "static/img/examshare_lbt_pic1.0950cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examshare_lbt_pic1.png
// module id = /Eag
// module chunks = 0